// Shared between InboxIntegrationsPage.vue (edit an existing hook) and NewHook.vue (create a
// hook from Settings > Integrations) — both let an admin configure a Bitrix survey's WhatsApp
// quick-reply buttons and need to turn the button rows kept in `values.survey_buttons` into the
// shape `Integrations::Hook` validates: an ASCII `key` per button (derived from its label, since
// that's what a Bitrix automation rule calls back the survey-result webhook with) plus the
// label/status_field/status_value the admin entered.
export const slugifyButtonLabel = label => {
  const base = (label || '')
    .toString()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '_')
    .replace(/^_+|_+$/g, '');
  return base || 'boton';
};

// Returns undefined (not []) when there are no rows, so callers can `delete` the key from a
// settings payload rather than submit `survey_buttons: []`, which the backend schema rejects
// (`minItems: 1`).
export const buildBitrixSurveyButtonsPayload = surveyButtons => {
  const rows = Array.isArray(surveyButtons) ? surveyButtons : [];
  if (!rows.length) return undefined;

  const seenCounts = {};
  return rows.map(row => {
    const base = slugifyButtonLabel(row.label);
    seenCounts[base] = (seenCounts[base] || 0) + 1;
    const key = seenCounts[base] > 1 ? `${base}_${seenCounts[base]}` : base;
    return {
      key,
      label: row.label || '',
      status_field: row.status_field || '',
      status_value: row.status_value || '',
      reply_message: row.reply_message || '',
    };
  });
};

// Campos obligatorios por fila para que Bitrix::UpdateLeadService pueda resolver el estado real
// a escribir en Bitrix (ver update_lead_service.rb) -- sin esto la fila se guarda igual (el
// backend no lo exige a nivel de JSON schema) pero cada respuesta real termina mandándole a
// Bitrix un campo vacío en vez de un valor real. `reply_message` queda afuera a propósito:
// vacío es un estado válido (no se manda ningún mensaje para ese botón).
export const REQUIRED_BUTTON_FIELDS = ['label', 'status_field', 'status_value'];

// Cada campo de este widget se renderiza con `ignore` (ver BitrixSurveyButtonsConfig.vue) para
// que `survey_buttons` no participe del estado nativo de FormKit -- efecto colateral: ningún
// `validation="required"` de esos campos frena el submit del formulario solo. Hay que validar
// esto a mano antes de guardar. Devuelve los números de fila (1-based, para mostrarle al admin
// cuál falta completar) que tienen algún campo obligatorio vacío, o `[]` si está todo completo.
export const invalidBitrixSurveyButtonRows = surveyButtons => {
  const rows = Array.isArray(surveyButtons) ? surveyButtons : [];
  return rows
    .map((row, index) => ({ row, index }))
    .filter(({ row }) =>
      REQUIRED_BUTTON_FIELDS.some(field => !String(row[field] || '').trim())
    )
    .map(({ index }) => index + 1);
};
